import axios from 'axios'

export default {
    data () {
        return {
            occupancyGraphData: {},
        }
    },
    computed: {
        occupancyDataByAz () {
            const occupancyDataByAz = []
            if (this.occupancyGraphData.orsInformationArrayList) {
              for (const dataByAz of this.occupancyGraphData.orsInformationArrayList) {
                occupancyDataByAz.push({ yValue: dataByAz.bleOrs.map(({ bleOrs }) => bleOrs), azName: dataByAz.azName })
              }
            }
            return occupancyDataByAz
          },
          occChartModel () {
            return {
              labels: this.occupancyGraphData.timeBucket,
              datasets: [
                ...this.occupancyDataByAz.map(dataByAz => {
                  return {
                    data: dataByAz.yValue,
                    borderColor: '#50847B',
                    borderWidth: 2,
                    cubicInterpolationMode: 'monotone',
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    fill: 'origin',
                    backgroundColor: '#50847B',
                  }
                }),
                {
                  data: this.occupancyGraphData.thresholds,
                  fill: 'end',
                  backgroundColor: 'rgba(209, 101, 101, 0.3)',
                  borderWidth: 2,
                  cubicInterpolationMode: 'monotone',
                  pointRadius: 0,
                  pointHoverRadius: 0,
                },
              ],
            }
          },
          maxOccupancyGraph () {
            return this.occupancyGraphData.max?.[0] ?? 10
          },
          thresholdOccupancyGraph () {
            return this.occupancyGraphData.thresholds[0]
          },
    },
    methods: {
        async getOccupancyGraphData (startDate, endDate) {
          return await axios.get(`${this.$store.state.baseURL}/occupancyscore/${this.propertyId}/${startDate}/${endDate}`, {})
        },
    },
}
